import HomeIndex from "./home.vue"
import simple from "./data/simple.vue";
let a = Object.assign({ HomeIndex, simple })
export default a;
